export default __webpack_public_path__ + "static/media/chat.8b951f2f.mp3";